class RTEFormatter extends HTMLElement {
  connectedCallback() {
    for (const table of this.querySelectorAll('table')) {
      if (table.parentElement?.classList.contains('horizon-rte-table-wrapper')) continue;

      const parent = table.parentNode;
      if (!parent) continue;

      const wrapper = document.createElement('div');
      wrapper.classList.add('horizon-rte-table-wrapper');
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
